import { BetType, OddDTO } from '../interface/odds';
import { BetArgs } from '../interface/bets';
import { getBetValue } from './getBetValue';

export function calculateOddValueFromMatchAndBetArgs(match: OddDTO, betArgs: BetArgs, isParlay = false) {
  const { BetType: betType, BetPosition, SpecialValue, IsFH, OddsValue } = betArgs;
  let _indexed = betArgs._indexed ?? 0;
  switch (betType) {
    case 'HDP':
      const foundHDPIndex = match.HDP_List.findIndex((item) => {
        if (IsFH) {
          return Number(item.HDP_SpecialValue_FH) === SpecialValue;
        }
        return Number(item.HDP_SpecialValue_FT) === SpecialValue;
      });
      if (foundHDPIndex !== -1) {
        _indexed = foundHDPIndex;
      }

      if (match.HDP_List[_indexed!]) {
        if (BetPosition === 'HOME') {
          if (!IsFH) {
            return {
              OddsValue: getBetValue(
                betType as BetType,
                match.HDP_List[_indexed!].HDP_HomeTeam_OddsValue_FT.MY_A,
                isParlay
              ),
              SpecialValue: Number(match.HDP_List[_indexed!].HDP_SpecialValue_FT),
            };
          } else {
            return {
              OddsValue: getBetValue(
                betType as BetType,
                match.HDP_List[_indexed!].HDP_HomeTeam_OddsValue_FH.MY_A,
                isParlay
              ),
              SpecialValue: Number(match.HDP_List[_indexed!].HDP_SpecialValue_FH),
            };
          }
        } else {
          if (!IsFH) {
            return {
              OddsValue: getBetValue(
                betType as BetType,
                match.HDP_List[_indexed!].HDP_AwayTeam_OddsValue_FT.MY_A,
                isParlay
              ),
              SpecialValue: Number(match.HDP_List[_indexed!].HDP_SpecialValue_FT),
            };
          } else {
            return {
              OddsValue: getBetValue(
                betType as BetType,
                match.HDP_List[_indexed!].HDP_AwayTeam_OddsValue_FH.MY_A,
                isParlay
              ),
              SpecialValue: Number(match.HDP_List[_indexed!].HDP_SpecialValue_FH),
            };
          }
        }
      } else {
        return {
          OddsValue: OddsValue,
          SpecialValue: SpecialValue,
          _indexed: _indexed,
        };
      }

    case 'OU':
      const foundOUIndex = match.OU_List.findIndex((item) => {
        if (IsFH) {
          return Number(item.OU_SpecialValue_FH) === SpecialValue;
        }
        return Number(item.OU_SpecialValue_FT) === SpecialValue;
      });
      if (foundOUIndex !== -1) {
        _indexed = foundOUIndex;
      }

      if (match.OU_List[_indexed!]) {
        if (BetPosition === 'OVER') {
          if (!IsFH) {
            return {
              OddsValue: getBetValue(betType as BetType, match.OU_List[_indexed!].OU_OddsValue_Over_FT.MY_A, isParlay),
              SpecialValue: Number(match.OU_List[_indexed!].OU_SpecialValue_FT),
            };
          } else {
            return {
              OddsValue: getBetValue(betType as BetType, match.OU_List[_indexed!].OU_OddsValue_Over_FH.MY_A, isParlay),
              SpecialValue: Number(match.OU_List[_indexed!].OU_SpecialValue_FH),
            };
          }
        } else {
          if (!IsFH) {
            return {
              OddsValue: getBetValue(betType as BetType, match.OU_List[_indexed!].OU_OddsValue_Under_FT.MY_A, isParlay),
              SpecialValue: Number(match.OU_List[_indexed!].OU_SpecialValue_FT),
            };
          } else {
            return {
              OddsValue: getBetValue(betType as BetType, match.OU_List[_indexed!].OU_OddsValue_Under_FH.MY_A, isParlay),
              SpecialValue: Number(match.OU_List[_indexed!].OU_SpecialValue_FH),
            };
          }
        }
      } else {
        return {
          OddsValue: OddsValue,
          SpecialValue: SpecialValue,
          _indexed: _indexed,
        };
      }

    case 'X12':
      if (BetPosition === '1')
        if (!IsFH) {
          return {
            OddsValue: getBetValue(betType as BetType, match.X12?.X12_OddsValue_1_FT, isParlay),
            SpecialValue: 0,
          };
        } else {
          return {
            OddsValue: getBetValue(betType as BetType, match.X12?.X12_OddsValue_1_FH, isParlay),
            SpecialValue: 0,
          };
        }
      if (BetPosition === '2') {
        if (!IsFH) {
          return {
            OddsValue: getBetValue(betType as BetType, match.X12?.X12_OddsValue_2_FT, isParlay),
            SpecialValue: 0,
          };
        } else {
          return {
            OddsValue: getBetValue(betType as BetType, match.X12?.X12_OddsValue_2_FH, isParlay),
            SpecialValue: 0,
          };
        }
      }
      // betPosition = X
      if (!IsFH) {
        return {
          OddsValue: getBetValue(betType as BetType, match.X12?.X12_OddsValue_X_FT, isParlay),
          SpecialValue: 0,
        };
      } else {
        return {
          OddsValue: getBetValue(betType as BetType, match.X12?.X12_OddsValue_X_FH, isParlay),
          SpecialValue: 0,
        };
      }
    case 'OE':
      if (BetPosition === 'ODD') {
        if (!IsFH) {
          return {
            OddsValue: getBetValue(betType as BetType, match.OE?.OE_Odd_FT.MY_A, isParlay),
            SpecialValue: 0,
          };
        } else {
          return {
            OddsValue: getBetValue(betType as BetType, match.OE?.OE_Odd_FH.MY_A, isParlay),
            SpecialValue: 0,
          };
        }
      } else {
        if (!IsFH) {
          return {
            OddsValue: getBetValue(betType as BetType, match.OE?.OE_Even_FT.MY_A, isParlay),
            SpecialValue: 0,
          };
        } else {
          return {
            OddsValue: getBetValue(betType as BetType, match.OE?.OE_Even_FH.MY_A, isParlay),
            SpecialValue: 0,
          };
        }
      }
    case 'TG':
      return {
        // @ts-ignore
        OddsValue: getBetValue(betType as BetType, match.TG?.[`TG_${BetPosition}_${IsFH ? 'FH' : 'FT'}`], isParlay),
        SpecialValue: 0,
      };
    case 'DC':
      return {
        // @ts-ignore
        OddsValue: match.X12?.[`DC_${BetPosition}_${IsFH ? 'FH' : 'FT'}`],
        SpecialValue: 0,
      };
    case 'CS':
      return {
        // @ts-ignore
        OddsValue: match.CS?.[`${BetPosition === 'AOS' ? BetPosition : 'C' + BetPosition}_${IsFH ? 'FH' : 'FT'}`],
        SpecialValue: 0,
      };
    case 'HTFT':
      return {
        // @ts-ignore
        OddsValue: match.HTFT?.[`HTFT_${BetPosition}`],
        SpecialValue: 0,
      };
    case 'FGLG':
      let first = BetPosition.slice(0, 2);
      if (first === 'NG') first = 'FGLG';
      const second = {
        HOME: 'HomeTeam',
        AWAY: 'AwayTeam',
        '': 'NoGoal',
      }[BetPosition.slice(3)];
      const third = IsFH ? 'FH' : 'FT';
      return {
        // @ts-ignore
        OddsValue: match.FGLG?.[`FGLG_${[first, second, third].filter(Boolean).join('_')}`],
        SpecialValue: 0,
      };
    case 'OUT':
      return {
        OddsValue: match.Outright?.Outright_Home_FT,
        SpecialValue: 0,
      };
    case 'HP3':
      return {
        // @ts-ignore
        OddsValue: match.HP3?.[`${BetPosition}`],
        SpecialValue: 0,
      };
    case 'ATG':
      return {
        // @ts-ignore
        OddsValue: match.ATG?.[`${BetPosition}`],
        SpecialValue: 0,
      };
    case 'HTG':
      return {
        // @ts-ignore
        OddsValue: match.HTG?.[`${BetPosition}`],
        SpecialValue: 0,
      };
    case 'ETG':
      return {
        // @ts-ignore
        OddsValue: match.ETG?.[`${BetPosition}`],
        SpecialValue: 0,
      };
    case 'CNS':
      return {
        // @ts-ignore
        OddsValue: match.CNS?.[`${BetPosition}`],
        SpecialValue: 0,
      };
    case 'H1ETG':
      return {
        // @ts-ignore
        OddsValue: match.H1ETG?.[`${BetPosition}`],
        SpecialValue: 0,
      };
    default:
      return {
        OddsValue: 0,
        SpecialValue: 0,
      };
  }
}
